import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { ClerkFailed, ClerkLoaded, ClerkProvider } from "@clerk/clerk-react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "./index.css"
import App from "./App"
import AppErrorBoundary from "./components/AppErrorBoundary"
import { AuthBootOverlay, AuthFailedSignal, AuthReadySignal } from "./components/AuthBootOverlay"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
})

const clerkPubKey = "pk_live_Y2xlcmsuYXRsYXNieWhpbGxwcmltZS5jb20k"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <AuthBootOverlay />
      <ClerkProvider publishableKey={clerkPubKey}>
        <ClerkLoaded><AuthReadySignal><QueryClientProvider client={queryClient}><App /></QueryClientProvider></AuthReadySignal></ClerkLoaded>
        <ClerkFailed><AuthFailedSignal /></ClerkFailed>
      </ClerkProvider>
    </AppErrorBoundary>
  </StrictMode>
)
